import { Button } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';
import FormRadio from '../../Components/Form/FormRadio';

const FormRadioButtons = () => {
  const formContext = useForm<{ radioOption: string }>({
    mode: 'onTouched',
    defaultValues: {
      radioOption: '',
    },
  });

  const onSubmit = (data: { radioOption: string }) => {
    console.log(data);
  };

  return (
    <FormProvider {...formContext}>
      <form noValidate onSubmit={formContext.handleSubmit(onSubmit)}>
        <FormRadio
          name="radioOption"
          label="Select an Option"
          options={[
            { value: '1', label: 'Option 1', disabled: true },
            { value: '2', label: 'Option 2' },
            { value: '3', label: 'Option 3' },
          ]}
          rules={{ required: 'This field is required' }}
        />
        <Button
          type="submit"
          variant="contained"
          color="primary"
          sx={{ mt: 1 }}
        >
          Submit
        </Button>
      </form>
    </FormProvider>
  );
};

export default FormRadioButtons;
